import { FormControl, FormField, FormItem, FormMessage } from '@/shared/ui/form';
import SliderWithLabel from '@/shared/ui/slider-with-label';
import type { Control, FieldValues, Path } from 'react-hook-form';
import * as m from '@paraglide/messages';
import { useMemo } from 'react';
interface DiskSliderProps<TData extends FieldValues> {
  control: Control<TData>;
  name: Path<TData>;
  max: number;
  min: number;
  onlyIncrease?: boolean;
  defaultValue?: number;
  disabled?: boolean;
}
const diskExpansions = ['1', '25', '50'];
export const DiskSlider = <TData extends FieldValues,>({
  control,
  name,
  max,
  min,
  onlyIncrease = false,
  defaultValue = 5,
  disabled = false
}: DiskSliderProps<TData>) => {
  const diskExpansions = useMemo(() => {
    return [min, max];
  }, [min, max]);
  return <FormField name={name} control={control} render={({
    field: {
      value,
      onChange
    }
  }) => <FormItem>
          <FormControl>
            <div className="px-2">
              <SliderWithLabel disabled={disabled} step={1} min={min} max={max} unit={m.unit_GB()} value={[value]} defaultValue={[defaultValue]} onlyIncrease={onlyIncrease} onValueChange={vals => {
          const newValue = vals[0];
          if (onlyIncrease && newValue < defaultValue) {
            return;
          }
          onChange(newValue);
        }} />
              <div className="mt-2 -mx-1.5 flex items-center justify-between text-muted-foreground text-xs">
                {diskExpansions.map(expansion => <span key={expansion}>
                    {expansion}
                    {m.unit_GB()}
                  </span>)}
              </div>
            </div>
          </FormControl>
          <FormMessage />
        </FormItem>} data-sentry-element="FormField" data-sentry-component="DiskSlider" data-sentry-source-file="disk-slider.tsx" />;
};